<script lang="ts">
    import { t } from 'svelte-i18n';
    import logoImg from '$lib/assets/images/logo.png?as=run:0&w=134&format=avif;webp';
    import logoTextImg from '$lib/assets/images/logo-text-only.png?as=run:0&w=382&format=avif;webp';
    import IconMenuBars from '~icons/custom/menu-bars';
    import IconMenuX from '~icons/custom/menu-x';
    import IconShoppingCart from '~icons/custom/icon-cart';
    import Img from '@zerodevx/svelte-img';
    import { fade, slide } from 'svelte/transition';
    import { browser } from '$app/environment';
    import { afterNavigate } from '$app/navigation';
    import { useLocaleContext } from '$lib/context.js';
    import Button from '$lib/daisyUiComponents/Button.svelte';

    const lang = useLocaleContext();
    export let logoHref = `/${lang}`;
    export let showCart = false;
    export let cartLineItemAmount = 0;

    let scrollY = 0;
    let open = false;
    const toggle = () => (open = !open);

    $: if (browser) {
        if (open) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
    }

    afterNavigate(() => (open = false));
</script>

<svelte:window bind:scrollY />

<nav class="navbar z-20 fixed w-full items-start pointer-events-none">
    <div class="flex-1">
        <a
            class="btn btn-ghost w-fit h-12 lg:h-16 px-0 hover:bg-transparent pointer-events-auto no-animation"
            href={logoHref}
        >
            <Img src={logoImg} alt="BSA-Corse" loading="eager" class="h-12 lg:h-14 w-auto" />
            <Img
                src={logoTextImg}
                alt="BSA-Corse"
                loading="eager"
                class="{scrollY == 0 ? 'opacity-100' : 'opacity-0'} transition-all h-12 lg:h-14 w-auto"
            />
        </a>
    </div>

    <div class="flex lg:mr-2 pointer-events-auto">
        <Button
            btnStyle="ghost"
            href={showCart ? `/${lang}/shop/cart` : `/${lang}/shop`}
            class="w-28 h-12 -mr-10 bg-black rounded-l-full hover:bg-primary group relative"
        >
            <div class="w-full h-full py-2 pr-10 relative">
                <IconShoppingCart class="text-white h-full w-full" />
                {#if cartLineItemAmount}
                    <div
                        class="badge badge-primary rounded-full absolute -top-0.5 right-8 text-[12px] w-5 h-5 font-bold"
                    >
                        {cartLineItemAmount}
                    </div>
                {/if}
            </div>
        </Button>

        <div class="z-20">
            <input id="my-drawer" type="checkbox" class="drawer-toggle" />
            <button
                on:click={toggle}
                class="btn btn-square btn-ghost transition-colors hover:bg-primary group w-14 h-14 rounded-full bg-white flex justify-center items-center"
            >
                <IconMenuBars class="text-black group-hover:text-white transition-colors" />
            </button>
        </div>
    </div>
</nav>

{#if open}
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
        class="fixed top-0 bottom-0 right-0 left-0 bg-black/60 z-30 cursor-pointer"
        on:click={toggle}
        transition:fade={{ duration: 300 }}
    />
    <div
        class="fixed top-0 bottom-0 right-0 pb-8 lg:pb-0 w-[100vw] lg:w-[55vw] h-[100vh] bg-black z-30 flex flex-col justify-between"
        transition:slide={{ axis: 'x', duration: 200 }}
    >
        <div class="flex-1 flex flex-col">
            <div class="navbar">
                <div class="flex-1">
                    <a class="btn btn-ghost w-auto h-12 lg:h-16 hover:bg-transparent" href="/{lang}">
                        <Img src={logoImg} alt="BSA-Corse" loading="eager" class="h-12 lg:h-14 w-auto" />
                        <Img src={logoTextImg} alt="BSA-Corse" loading="eager" class="h-12 lg:h-14 w-auto" />
                    </a>
                </div>
                <div class="flex-none lg:mr-2">
                    <input id="my-drawer" type="checkbox" class="drawer-toggle" />
                    <button
                        on:click={toggle}
                        class="btn btn-square btn-ghost hover:bg-primary group w-14 h-14 rounded-full bg-white flex justify-center items-center"
                    >
                        <IconMenuX class="text-black group-hover:text-white transition-colors" />
                    </button>
                </div>
            </div>
            <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <ul class="flex-1 flex flex-col justify-evenly items-end p-8 w-full font-bold" on:click={toggle}>
                <slot />
            </ul>
        </div>
        <div class="flex gap-8 p-8 whitespace-nowrap">
            <div>
                <h4 class="text-gray-200 text-[20px] font-semibold mb-1 uppercase">
                    {$t('website.sidebar.details.get-in-touch')}
                </h4>
                <p class="text-[14px] text-gray-300">
                    E-Mail: info@bsa-corse.de<br />
                    Tel: +49 (0)6204 92909-0<br />
                    Fax: +49 (0)6204 92909-26
                </p>
            </div>
            <div>
                <h4 class="text-gray-200 text-[20px] font-semibold mb-1 uppercase">
                    {$t('website.sidebar.details.address')}
                </h4>
                <p class="text-[14px] text-gray-300">
                    Industriestrasse 30<br />
                    68519 Vierheim<br />
                    Germany
                </p>
            </div>
        </div>
    </div>
{/if}
